import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=aa9ba380&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa9ba380')) {
      api.createRecord('aa9ba380', component.options)
    } else {
      api.reload('aa9ba380', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=aa9ba380&", function () {
      api.rerender('aa9ba380', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/setting/sub-category/edit.vue"
export default component.exports